const SkillCategories = [{'color': '#3CB2D1', 'name': 'Frontend', 'category': 'front'}, 
{'color': '#FF5AB5', 'name': 'Backend', 'category': 'back'}, 
{'color': '#A766FF', 'name': 'Workflow & Tools', 'category': 'tools'}];

export default SkillCategories;